import { AccountSheet, AccountSheetRow, AccountSheetRowGroup } from '@/plugins/api'
import { upsertMany } from '@/helpers'
import moment from 'moment'
export default {
  namespaced: true,
  state: {
    accountSheets: [],
    isLoadingAccountSheets: false,
    accountSheetRows: [],
    accountSheetRowGroups: []
    // accountSheetContents: []
  },
  actions: {
    async fetchAccountSheets({ commit }) {
      try {
        commit('setIsLoadingAccountSheets', true)
        const accountSheets = await AccountSheet.fetch()
        commit('setAccountSheets', accountSheets)
      } catch (error) {
        throw error
      } finally {
        commit('setIsLoadingAccountSheets', false)
      }
    },
    async fetchAccountSheetRows({ commit }, { accountsheetId }) {
      const v = await AccountSheetRow.fetch({ account_sheet: accountsheetId })
      commit('setAccountSheetRows', v)
    },
    async fetchAccountSheetRowGroups({ commit }, { accountsheetId }) {
      const v = await AccountSheetRowGroup.fetch({ account_sheet: accountsheetId })
      commit('setAccountSheetRowGroups', v)
    },
    // async fetchAccountSheetContent({ commit, state }, { accountsheetId }) {
    //   const res = await AccountSheet.content(accountsheetId)
    //   commit(
    //     'setAccountSheetContents',
    //     upsertMany(state.accountSheetContents, { id: accountsheetId, data: res })
    //   )
    // },
    async recalculateContent({ commit, state }, { accountsheetId }) {
      const res = await AccountSheet.recalculate(accountsheetId)
      commit('setAccountSheetRowGroups', res)
    },
    async publishAccountSheet({ commit, state }, { accountsheetId }) {
      const res = await AccountSheet.publish(accountsheetId)
      commit('setAccountSheets', upsertMany(state.accountSheets, res))
      // commit('setAccountSheetRowGroups', res)
      // commit(
      //   'setAccountSheets',
      //   upsertMany(state.accountSheets, { id: accountsheetId, isPublished: true })
      // )
    },
    async cancelAccountSheet({ commit, state }, { accountsheetId, data }) {
      await AccountSheet.cancel(accountsheetId, data)
      commit(
        'setAccountSheets',
        upsertMany(state.accountSheets, { id: accountsheetId, isCanceled: true })
      )
    },
    async fetchAccountSheet({ commit, state }, { accountsheetId }) {
      const res = await AccountSheet.fetchOne(accountsheetId)

      commit('setAccountSheets', upsertMany(state.accountSheets, res))
    },

    async createAccountSheet({ commit, state }, { data }) {
      const v = await AccountSheet.create(data)
      commit('setAccountSheets', [v, ...state.accountSheets])
    },
    async createAccountSheetRow({ commit, state }, { data }) {
      const v = await AccountSheetRow.create(data)
      commit('setAccountSheetRows', [...state.accountSheetRows, v])
    },
    async createManyAccountSheetRows({ commit, state }, { data }) {
      const v = await AccountSheetRow.createMany(data)
      commit('setAccountSheetRows', [...state.accountSheetRows, ...v])
    },

    async updateAccountSheet({ commit, state }, { id, ...data }) {
      const v = await AccountSheet.update(id, data)
      commit('setAccountSheets', upsertMany(state.accountSheets, v))
    },
    async updateAccountSheetRow({ commit, state }, { id, ...data }) {
      const v = await AccountSheetRow.update(id, data)
      commit('updateRowWithinGroup', v)
    },
    async updateAccountSheetRowGroup({ commit, state }, { id, ...data }) {
      const v = await AccountSheetRowGroup.update(id, data)
      commit('setAccountSheetRowGroups', upsertMany(state.accountSheetRowGroups, v))
    },

    async removeAccountSheet({ commit, state }, id) {
      commit(
        'setAccountSheets',
        state.accountSheets.filter(i => i.id !== id)
      )
      await AccountSheet.remove(id)
    },
    async removeAccountSheetRow({ commit, state }, id) {
      commit(
        'setAccountSheetRows',
        state.accountSheetRows.filter(i => i.id !== id)
      )
      await AccountSheetRow.remove(id)
    }
  },
  mutations: {
    setAccountSheets(state, v) {
      state.accountSheets = v
    },
    updateRowWithinGroup(state, v) {
      state.accountSheetRowGroups = state.accountSheetRowGroups.map(i => {
        if (i.id !== v.account_sheet_row_group.id) {
          return i
        }
        return { ...i, account_sheet_rows: upsertMany(i.account_sheet_rows, v) }
      })
    },
    // setAccountSheetContents(state, v) {
    //   state.accountSheetContents = v
    // },
    setAccountSheetRows(state, v) {
      state.accountSheetRows = v
    },
    setAccountSheetRowGroups(state, v) {
      state.accountSheetRowGroups = v
    },
    setIsLoadingAccountSheets(state, v) {
      state.isLoadingAccountSheets = v
    }
  }
}
